var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35078 1.18672L3.90078 3.7168C4.02031 3.85625 4.1 4.01563 4.1 4.175C4.1 4.31445 4.02031 4.49375 3.90078 4.61328L1.35078 7.14336C1.17148 7.32266 0.892578 7.38242 0.653516 7.28281C0.414453 7.1832 0.275 6.98398 0.275 6.725V1.625C0.275 1.38594 0.414453 1.14688 0.653516 1.04727C0.892578 0.947656 1.17148 1.00742 1.35078 1.18672Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.4e4a50c905afed05992f43c748f10b51.svg";
export { ForwardRef as ReactComponent };